module.exports = {"total":"0","rows":[]}


//////////////////
// WEBPACK FOOTER
// ./static/tinitial.json
// module id = 437
// module chunks = 1